import { formatBytes } from "./Feedback";
import { useApi } from "../useApi";

// The project's storage and database quota, before anyone uploads (task 2026-10-05-project-
// databases-and-storage-are-measured-and-capped). GET /api/projects/{id}/quota -> {s3, database:
// {used, quota, percent, state}}; says nothing while both are `none` or `ok`, warns from the
// administrator's warn share, and says why uploads are refused once a quota is full (the server
// answers 507 with the same reason). A failed read shows nothing: the upload still says why.

const WARN = { background: "rgba(217,119,6,0.08)", border: "1px solid rgba(217,119,6,0.35)", color: "#92400e" };
const FULL = { background: "rgba(220,38,38,0.06)", border: "1px solid rgba(220,38,38,0.30)", color: "#991b1b" };

function sentence(what, s, refused) {
  const amount = `${formatBytes(s.used)} of ${formatBytes(s.quota)} (${s.percent} %)`;
  if (s.state === "full") return `This project's ${what} quota is full: ${amount}. New ${refused} are refused until an administrator purges old data or raises the quota.`;
  return `This project uses ${amount} of its ${what} quota.`;
}

export default function QuotaNote({ projectId }) {
  const r = useApi(projectId ? `/projects/${projectId}/quota` : null);
  const q = r.data;
  if (!q) return null;
  const notes = [];
  if (q.s3 && (q.s3.state === "warn" || q.s3.state === "full")) notes.push({ key: "s3", s: q.s3, text: sentence("storage", q.s3, "uploads") });
  if (q.database && (q.database.state === "warn" || q.database.state === "full")) notes.push({ key: "db", s: q.database, text: sentence("database", q.database, "imports") });
  if (notes.length === 0) return null;
  return (
    <>
      {notes.map(n => (
        <div key={n.key} role={n.s.state === "full" ? "alert" : "status"}
             style={{ padding: "10px 14px", borderRadius: 8, fontSize: 13, margin: "0 0 14px", ...(n.s.state === "full" ? FULL : WARN) }}>
          {n.text}
        </div>
      ))}
    </>
  );
}
